<template>
  <div>
    <div v-if="$route.name !== 'Routing' && userType !== 'PARTY'">
      <!-- <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      /> -->
      <router-link
        to="/dashboard"
        v-if="$route.name !== 'Dashboard' && $route.name!=='Admin Page'  || !vendorFlag"
      >
        <div
          class="letsTalkButton"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
          title="Return to Vendor Dashboard"
        >
          <div id="telephoneIcon">
            <md-icon style="color: white">menu</md-icon>
          </div>
        </div>
      </router-link>
    </div>
    <div v-if="userType == 'VENDOR' && $route.name !== 'Routing' && bothTypeUser">
      <router-link
        to="/routing"
        v-if="$route.name == 'Dashboard'"
      >
        <div
          class="letsTalkButtonRoute"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
          title="Return to Routing"
        >
          <div id="telephoneIcon">
            <md-icon style="color: white">menu</md-icon>
          </div>
        </div>
      </router-link>
    </div>
    <div v-if="userType == 'PARTY' && $route.name !== 'Routing' && bothTypeUser">
      <router-link
        to="/routing"
        v-if="$route.name !== 'PartyDashboard'"
      >
        <div
          class="letsTalkButton"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
          title="Return to Routing"
        >
          <div id="telephoneIcon">
            <md-icon style="color: white">menu</md-icon>
          </div>
        </div>
      </router-link>
    </div>
    <!-- For PARTY PORTAL CODE START-->
    <div
      v-if="userType == 'PARTY' && $route.name !== 'Routing'"
      class="sidebar"
      :data-color="activeColor"
      :data-image="sidebarBackgroundImage"
      :data-background-color="backgroundColor"
      :style="sidebarStyle"
    >
      <div class="logo">
        <a class="simple-text logo-mini" target="_blank">
          <div style="padding: 4px 0">VT</div>
        </a>
        <a class="simple-text logo-normal" target="_blank">
          <template v-if="$route.meta.rtlActive">VATIKA</template>
          <template v-else>{{ title }}</template>
        </a>
        <div class="navbar-minimize">
          <md-button
            id="minimizeSidebar"
            class="md-round md-just-icon md-transparent"
            @click="minimizeSidebar"
          >
            <i
              class="material-icons text_align-center visible-on-sidebar-regular"
              >more_vert</i
            >
            <i
              class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
              >view_list</i
            >
          </md-button>
        </div>
      </div>
      <div class="sidebar-wrapper" ref="sidebarScrollArea">
        <slot></slot>
        <md-list class="nav">
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              >
              </sidebar-item>
            </sidebar-item>
          </slot>
        </md-list>
      </div>
    </div>
    <!-- For PARTY PORTAL CODE END-->
    <!-- <div
      v-if="userType == 'PARTY' && $route.name !== 'Routing'"
      class="sidebar"
      :data-color="activeColor"
      :data-image="sidebarBackgroundImage"
      :data-background-color="backgroundColor"
      :style="sidebarStyle"
    >
      <div class="logo">
        <a class="simple-text logo-mini" target="_blank">
          <div style="padding: 4px 0">
            VT
          </div>
        </a>
        <a class="simple-text logo-normal" target="_blank">
          <template v-if="$route.meta.rtlActive">VATIKA</template>
          <template v-else>{{ title }}</template>
        </a>
        <div class="navbar-minimize">
          <md-button
            id="minimizeSidebar"
            class="md-round md-just-icon md-transparent"
            @click="minimizeSidebar"
          >
            <i
              class="material-icons text_align-center visible-on-sidebar-regular"
              >more_vert</i
            >
            <i
              class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
              >view_list</i
            >
          </md-button>
        </div>
      </div>
      <div class="sidebar-wrapper" ref="sidebarScrollArea">
        <slot></slot>
        <md-list
          class="nav"
          v-if="
            !$store.state.auth.isNewVendor ||
              $store.state.auth.isNewVendor == 'false'
          "
        >
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              >
              </sidebar-item>
            </sidebar-item>
          </slot>
        </md-list>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "sidebar",
  data() {
    return {
      userType: null,
      bothTypeUser:null
    };
  },
  props: {
    title: {
      type: String,
      default: "Vatika" ? "Vatika" : "Delhivery",
    },
    rtlTitle: {
      type: String,
      default: "توقيت الإبداعية",
    },
    activeColor: {
      type: String,
      default: "green",
      validator: (value) => {
        let acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarBackgroundImage: {
      type: String,
      default: require("@/assets/img/sidebar-2.jpg"),
    },
    imgLogo: {
      type: String,
      default: require("@/assets/img/vue-logo.png"),
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: `${process.env.VUE_APP_BASE_URL}/img/vue-logo.png`,
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.$sidebar.toggleMinimize();
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  mounted() {
   this.userType = sessionStorage.getItem("userType");
   this.bothTypeUser = sessionStorage.getItem('bothTypeUser')
    this.minimizeSidebar();
    // if (this.$route.name == "Change Password") {
    //   this.vendorFlag = sessionStorage.isNewVendor;
    // }
  },
  updated() {
  this.userType = sessionStorage.getItem("userType");
  },
  methods: {
    vendorFlag() {
      if (this.$route.name == "Change Password") {
        return sessionStorage.isNewVendor;
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    // FOR PARTY PORTAL START //
    setUserType(type) {
      if (type === "party") {
        this.$store.dispatch("setUserType", "PARTY");
      } else if (type === "vendor") {
        this.$store.dispatch("setUserType", "VENDOR");
      }
    },
    // FOR PARTY PORTAL END //
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.sidebarBackgroundImage})`,
      };
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
.letsTalkButton {
  width: 15px;
  height: 50px;
  position: fixed;
  top: 75%;
  right: 0;
  background-color: black;
  z-index: 200;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  box-shadow: #003145 4px 4px 4px;
  padding: 10px;
  transition: width 0.7s ease;
}
.letsTalkButton:hover {
  width: 45px;
  cursor: pointer;
}
.letsTalkButtonRoute {
  width: 15px;
  height: 50px;
  position: fixed;
  top: 85%;
  right: 0;
  background-color: black;
  z-index: 200;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  box-shadow: #003145 4px 4px 4px;
  padding: 10px;
  transition: width 0.7s ease;
}
.letsTalkButtonRoute:hover {
  width: 45px;
  cursor: pointer;
}
</style>
